// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* Global styles for auth callback page */\nbody.auth-callback-page {\n  background-color: #000;\n  color: #fff;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
